import { Injectable, EventEmitter } from '@angular/core';
import { HttpService } from '../../services/http.service';

import { SnAuthService } from '@insight/serenity-auth';
import { SnEnvService } from '@insight/serenity-env';
import { PersonaService } from '../api/services';
import { Persona } from '../enums/Persona';

@Injectable()
export class PermissionsService {
  private _initTries = 0;
  private _userPermissions: string[] = [];

  private _allowedPersonas = [
    Persona.ClientBillingSuperUser, 
    Persona.ClientBillingManager,
    Persona.ClientBillingUser,
    Persona.ClientBillingTractUser,
    Persona.ClientBillingFinanceUser];

  private _nonFinancePersonas = [
    Persona.ClientBillingSuperUser, 
    Persona.ClientBillingManager,
    Persona.ClientBillingUser,
    Persona.ClientBillingTractUser
  ];

  private usersPersonas = [];

  constructor(private _authService: SnAuthService, private _httpService: HttpService, private _envService: SnEnvService, private _personaService: PersonaService) {
  }
  
  public async getPersonas() {
    if (this.usersPersonas.length === 0) {
      let resp = await this._personaService.GetUserPersonas({}).toPromise();
      this.usersPersonas = resp.split("|");
    }

    return this.usersPersonas;
  }

  public async hasApplicationAccess() {
    let personas = await this.getPersonas();

    return this._allowedPersonas.filter(ap => personas.includes(ap)).length > 0;
  }

  hasPersona(persona: string): boolean {
    return this.usersPersonas.findIndex(c => c === persona) >= 0;
  }

  public hasAtLeastOnePersona(personas: Array<Persona>) : boolean {
    if(personas === undefined) {
      return false;
    }

    return this.usersPersonas.filter(persona => personas.includes(persona)).length > 0;
  }

  hasPermission(permission: string): boolean {
    return this._userPermissions.indexOf(permission) >= 0;
  }

  public canAccessRoute(targetUrl: string): boolean {
    let route = this.parseRoute(targetUrl);
    let routePersonas = this.personaRoutePermissions.get(route);

    return this.hasAtLeastOnePersona(routePersonas);
  }

  private parseRoute(url: string): string {
    // Pull out route from provided url
    // '/landing/extra/parameters' will be converted into 'landing'
    if(url.indexOf('/') == 0) {
      return url.split('/')[1];
    }

    // If the url doesn't start with a /, it's already a route
    return url;
  }

  public getFirstValidRoute(): string {
    for (let [route, routePersonas] of this.personaRoutePermissions.entries()) {
      let validRoute = this.hasAtLeastOnePersona(routePersonas);

      if (validRoute) {
        return route;
      }
    }

    return '';
  }

  private personaRoutePermissions = new Map([
    ['landing', this._nonFinancePersonas],
    ['manual-usage-landing', this._nonFinancePersonas],
    ['bulk-usage', this._nonFinancePersonas],
    ['aggregation', this._nonFinancePersonas],
    ['aggregation-transmit', this._nonFinancePersonas],
    ['file-portal', this._allowedPersonas],
    ['file-config', this._nonFinancePersonas],
    ['client-configure', this._nonFinancePersonas]
  ]);
}
